import { CellContext, IIdentity } from '.';

export interface CellComponent<T extends IIdentity> {
  context: CellContext<T>;
}
